import { Plus } from 'lucide-react';
import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import CreateGroup from './CreateGroup';
import GroupList, { type GroupListRef } from './GroupListing';
import useAppAbilities from '@/components/abilities';
import NotFound from '@/components/blocks/NotFound';
import PageHeader from '@/components/common/PageHeader';

const GroupManagementPage = () => {
    const { t } = useTranslation('groups');
    const abilities = useAppAbilities();
    const [newGroupModalOpen, setNewGroupModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    const groupListRef = useRef<GroupListRef>(null);

    const handleAddGroupClick = () => {
        setNewGroupModalOpen(true);
    };

    const handleGroupCreated = () => {
        setNewGroupModalOpen(false);
        if (groupListRef.current) {
            groupListRef.current.refetch();
        }
    };

    if (!abilities.canViewGroups()) {
        return <NotFound />;
    }

    return (
        <div className="flex h-full flex-col gap-5">
            <div className="flex w-full flex-col gap-5 rounded-[10px] lg:gap-10">
                <PageHeader
                    title={t('title')}
                    searchProps={{
                        value: searchQuery,
                        onChange: setSearchQuery,
                        placeholder: t('groupList.searchPlaceholder'),
                        ariaLabel: t('groupList.ariaLabel'),
                    }}
                    actionButton={{
                        label: t('groupList.createButton'),
                        onClick: handleAddGroupClick,
                        show: abilities.canCreateGroups(),
                        icon: <Plus className="h-4 w-4" />,
                    }}
                />
                <GroupList ref={groupListRef} searchText={searchQuery} />
            </div>

            <CreateGroup
                open={newGroupModalOpen}
                onClose={() => setNewGroupModalOpen(false)}
                onCreated={handleGroupCreated}
            />
        </div>
    );
};

export default GroupManagementPage;
